import { AudioListener, PerspectiveCamera } from "three";
import { preferencesService } from "../preferences/PreferencesService";
import { VrHud } from "./vrhud/VrHud";
export const camera = {
    perspectiveCam: new PerspectiveCamera(45, typeof window !== "undefined" && window.document !== undefined ? window.innerWidth / window.innerHeight : 1.0, 0.1, 1000),
    audioListener: new AudioListener(),
    vrHud: new VrHud()
};
// the audioListener to play audio for the active player is attached to the one and only camera
camera.perspectiveCam.add(camera.audioListener);
// add VR HUD to the camera so it moves with it
camera.perspectiveCam.add(camera.vrHud);
// get initial speaker activation
camera.audioListener.setMasterVolume(preferencesService.getPreferredValue("speakersDefaultEnabled") === true ? 1.0 : 0.0);
